import api from "./ApiService";

const getInvestorMappings = (queryString: string) => {
  return api
    .get<any>(
      process.env.REACT_APP_API_BASE_URL + `/InvestorMapping?${queryString}`
    )
    .then((response: any) => response);
};

const createInvestorMapping = (data: any) => {
  return api
    .post<any>(process.env.REACT_APP_API_BASE_URL + `/InvestorMapping`, data)
    .then((response: any) => response);
};

const updateInvestorMapping = (data: any) => {
  return api
    .put<any>(process.env.REACT_APP_API_BASE_URL + `/InvestorMapping`, data)
    .then((response: any) => response);
};

const InvestorMappingService = {
  getInvestorMappings,
  createInvestorMapping,
  updateInvestorMapping,
};

export default InvestorMappingService;
